import "highcharts/modules/drilldown";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import  { Fragment } from "react";

// Initialize drilldown module

export const PopularBoothSoldView = () => {
  const yellow = "#fce647";

  const chartOptions: Highcharts.Options = {
    chart: {
      type: "column",
      backgroundColor: "transparent"
    },
    title: {
      text: "Popular Items Sold "
    },
    xAxis: {
      type: "category"
    },
    yAxis: {
      title: {
        text: "Total sold"
      }
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      series: {
        borderWidth: 0,
      dataLabels: {
          enabled: true,
          inside: true,
          style: {
            textOutline: "none",
            color: "#000",
            fontWeight: "bold",
          },
        },
        color: yellow
      }
    },
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        '<span style="color:' + yellow + '">{point.name}</span>: <b>{point.y}</b><br/>'
    },
    series: [
      {
        name: "Items",
        type: "column",
        color: yellow,
        // Removed colorByPoint: true to make all bars same yellow
        data: [
          { name: "T-shirt", y: 100, drilldown: "T-shirt" },
          { name: "Hoodies", y: 80, drilldown: "Hoodies" },
          { name: "Cap", y: 60, drilldown: "Cap" },
          { name: "Bottle", y: 90, drilldown: "Bottle" },
          { name: "Shoes", y: 70, drilldown: "Shoes" }
        ]
      }
    ],
    drilldown: {
      series: [
        {
          name: "T-shirt",
          id: "T-shirt",
          data: [
            ["Red", 30],
            ["Blue", 40],
            ["Green", 30]
          ],
          type: "column",
          color: yellow
        },
        {
          name: "Hoodies",
          id: "Hoodies",
          data: [
            ["Black", 20],
            ["White", 30],
            ["Grey", 30]
          ],
          type: "column",
          color: yellow
        },
        {
          name: "Cap",
          id: "Cap",
          data: [
            ["Snapback", 40],
            ["Beanie", 20]
          ],
          type: "column",
          color: yellow
        },
        {
          name: "Bottle",
          id: "Bottle",
          data: [
            ["Plastic", 50],
            ["Steel", 40]
          ],
          type: "column",
          color: yellow
        },
        {
          name: "Shoes",
          id: "Shoes",
          data: [
            ["Sneakers", 40],
            ["Boots", 30]
          ],
          type: "column",
          color: yellow
        }
      ]
    }
  };

  return (
    <Fragment>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </Fragment>
  );
};
